import {
    IonButton,
    IonCard,
    IonContent,
    IonFooter,
    IonItem,
    IonLabel,
    IonPage,
    IonProgressBar,
    IonText,
    IonTitle,
    useIonRouter,
} from "@ionic/react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { HeaderComponent } from "../../components";
import { Geolocation } from "@capacitor/geolocation";
import { routes } from "../../route/constants";
import { useMatch } from "../../components/hooks/match";
import { GpsMap, GpsMapType } from "../../components/GpsMapComponent";
import { trackEvent } from "../../services/analytics/analyticsService";
import "./onBoarding.css";
import "../register/register.css";
import { isAndroid, isIos } from "../../services/platformDetection";
import exampleMatch from "../../support/example-result.json";
import { MatchPhone } from "refsix-js-models";
import { ScorzaCard } from "../../components/stats/ScorzaCard";

const demoMatchId = "example-result1";

export const OnBoardingShareLocationData: FC = () => {
    const { t } = useTranslation();
    const route = useIonRouter();

    const demoMatch = useMatch(demoMatchId);
    const fallbackMatch = exampleMatch.match as unknown as MatchPhone;
    const matchForDisplay = demoMatch ?? fallbackMatch;

    const askForPermissionToUseLocation = async () => {
        if (isIos() || isAndroid()) {
            const permission = await Geolocation.checkPermissions();
            if (permission.location !== "granted") {
                await Geolocation.requestPermissions();
            }

            if (permission.location === "granted") {
                trackEvent("shareLocationData", {});
            }
        }
        route.push(
            routes.onBoardingShareHealthData,
            "forward",
            "replace"
        );
    };

    return (
        <IonPage>
            <HeaderComponent
                title={t("help.onBoarding.performanceData")}
                showProgressBar={true}
                progressValue={0.8}
            />
            <IonContent>
                <IonCard color="transparet">
                    <h2
                        data-testid="share-location-data-heading"
                        className="onboarding-section-header"
                    >
                        {t("help.onBoarding.shareLocationData")}
                    </h2>
                    <p style={{ fontSize: 16 }}>
                        <IonText className="align-center">
                            {t("help.onBoarding.needLocationAccess")}
                        </IonText>
                    </p>
                </IonCard>

                <ScorzaCard
                    className="onboarding-heatmap"
                    title={t("general.heatmap")}
                >
                    <GpsMap
                        match={matchForDisplay}
                        mapType={GpsMapType.Heatmap}
                        useDummyData={true}
                        testId="onboarding-heatmap"
                    ></GpsMap>
                </ScorzaCard>
            </IonContent>
            <IonFooter>
                <IonButton
                    data-testid="share-location-data-next-button"
                    expand="block"
                    onClick={() => askForPermissionToUseLocation()}
                >
                    {t("general.next")}
                </IonButton>
            </IonFooter>
        </IonPage>
    );
};
